module.exports = __webpack_public_path__ + "static/media/45.0374fd13.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/45.png
// module id = 469
// module chunks = 0